import { Check } from 'lucide-react';
import ListIdentity from './ListIdentity';

/**
 * A record to pick in a searched list (« Créer une mission » on a group, the
 * records of a task): its icon in a small frame, its name, a detail under it
 * and, on the right, an `aside` (a tag). `uppercase`: a company name, written
 * in capitals. `role` and `ariaSelected` make it an option of a listbox; a
 * `onMouseDown` that prevents the default keeps the focus in the search.
 * `checked` (true or false) draws a box to tick before it, for a list where
 * several are picked; `indented` sets it under the row it belongs to.
 */
const PickOption = ({ icon: Icon, name, detail, aside, uppercase = false, role, ariaSelected, onMouseDown, onClick, checked, indented = false }) => (
  <button
    type="button"
    role={role}
    aria-selected={ariaSelected}
    onMouseDown={onMouseDown}
    onClick={onClick}
    className={`flex w-full items-center gap-3 rounded-lg px-2 py-2 text-left transition-colors hover:bg-gray-50 focus-visible:bg-gray-50 focus-visible:outline-none ${
      indented ? 'pl-9' : ''
    }`}
  >
    {checked !== undefined && (
      <span
        aria-hidden="true"
        className={`flex size-4 shrink-0 items-center justify-center rounded border transition-colors ${
          checked ? 'border-yellow-500 bg-yellow-500 text-white' : 'border-gray-300 bg-white'
        }`}
      >
        {checked && <Check size={12} strokeWidth={3} />}
      </span>
    )}
    <ListIdentity icon={Icon} name={name} detail={detail} uppercase={uppercase} size="sm" />
    {aside && <span className="ml-auto shrink-0">{aside}</span>}
  </button>
);

export default PickOption;
